import { render } from "./AdminSysProjectsTab.vue?vue&type=template&id=c70c091c&ts=true"
import script from "./AdminSysProjectsTab.vue?vue&type=script&lang=ts"
export * from "./AdminSysProjectsTab.vue?vue&type=script&lang=ts"

import "./AdminSysProjectsTab.vue?vue&type=style&index=0&id=c70c091c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__